export enum Purpose {
    AVATAR = 1,
    COVER,
    GALLERY,
    LOGO,
}
